import { boolean, number, object, string, ref } from 'yup';

export const updateAccountSchema = object({
  email: string().max(128, 'Email must be 128 characters or less.'),
  address_1: string().max(64, 'Address must be 64 characters or less.'),
  city: string().max(24, 'City must be 24 characters or less.'),
  company: string().max(128, 'Company must be 128 characters or less.'),
  country: string()
    .min(2, 'Country code must be two letters.')
    .max(2, 'Country code must be two letters.'),
  first_name: string().max(50, 'First name must be 50 characters or less.'),
  last_name: string().max(50, 'Last name must be 50 characters or less.'),
  address_2: string().max(64, 'Address must be 64 characters or less.'),
  phone: string().max(32, 'Phone number must be 32 characters or less.'),
  state: string().max(24, 'State must be 24 characters or less.'),
  tax_id: string().max(100, 'Tax ID must be 100 characters or less.'),
  zip: string().max(16, 'Zip code must be 16 characters or less.'),
});

export const CreditCardSchema = object({
  card_number: string()
    .required('Credit card number is required.')
    .min(13, 'Credit card number must be between 13 and 23 characters.')
    .max(23, 'Credit card number must be between 13 and 23 characters.'),
  expiry_year: number()
    .required('Expiration year is required.')
    .min(new Date().getFullYear(), 'Expiration year must not be in the past.')
    .max(9999, 'Expiration year must be four digits.'),
  expiry_month: number()
    .required('Expiration month is required.')
    .min(1, 'Expiration month must be a number from 1 to 12.')
    .max(12, 'Expiration month must be a number from 1 to 12.'),
});

export const CreateUserSchema = object({
  email: string()
    .required('Email address is required.')
    .email('Must be a valid email address.'),
  password: string()
    .required('Password is required.')
    .min(8, 'Password must be between 8 to 32 characters.')
    .max(32, 'Password must be between 8 to 32 characters.')
    .matches(/[A-Z]/, 'password must have at least one capital letter'),
});

export const LoginUserSchema = object({
  email: string()
    .required('Email address is required.')
    .email('Must be a valid email address.'),
  password: string()
    .required('Password is required.')
    .min(8, 'Password must be between 8 to 32 characters.')
    .max(32, 'Password must be between 8 to 32 characters.')
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must be at least 8 characters with at least one capital letter and one special character'
    ),
});

export const EmailSchema = object({
  email: string()
    .required('Email address is required.')
    .email('Must be a valid email address.'),
});

export const PhoneSchema = object({
  phone: string().required('Phone Number is required.'),
});


export const UpdateUserSchema = object({
  username: string()
    .min(3, 'Username must be between 3 and 32 characters.')
    .max(32, 'Username must be between 3 and 32 characters.'),
  email: string().email('Must be a valid email address.'),
  restricted: boolean(),
});

export const ResetPasswordSchema = object({
  password: string()
    .required('Password is required.')
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must be at least 8 characters with at least one capital letter and one special character'
    ),
});

export const UpdatePasswordSchema = object({
  existing_password: string().required('Current Password is required.'),
  password: string()
    .required('New Password is required.')
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Password must be at least 8 characters with at least one capital letter and one special character'
    ),
  confirmPassword: string()
    .required('Confirm password is required.')
    .oneOf(
      [ref('password'), null],
      'Confirm Password do not match with new password'
    )
    .matches(
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      'Confirm Password must be at least 8 characters with at least one capital letter and one special character'
    ),
});
